import { render } from "./CategorySearchPage.vue?vue&type=template&id=60557042&scoped=true"
import script from "./CategorySearchPage.vue?vue&type=script&lang=js"
export * from "./CategorySearchPage.vue?vue&type=script&lang=js"

import "./CategorySearchPage.vue?vue&type=style&index=0&id=60557042&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60557042"]])

export default __exports__